import { Component, OnInit, ViewChild } from '@angular/core';
import { Pedido } from '../pedido.model';
import { EstadoPedido } from '../estado-pedido.model';
import { ActivatedRoute, Router } from '@angular/router';
import { BackendService } from '../../core/backend.service';
import { SnackService } from '../../shared-services/snack.service';
import { DialogService } from '../../shared-components/modals/dialog.service';
import { ClienteService } from '../../core/cliente.service';
import { DomSanitizer } from '@angular/platform-browser';
import { Imagen } from '../../productos/imagen.model';
import { IImage } from 'ng-simple-slideshow/src/app/modules/slideshow/IImage';
import { ImagenPedido } from '../imagen-pedido.model';
import { Observable } from 'rxjs/Observable';
import { MotivosRechazo } from '../../cliente/motivosRechazo/motivosRechazo.model';
import { SubclienteMonto } from '../../cliente/subclienteMonto.model';
import { Subcliente } from '../../cliente/subcliente.model';
import { NavigationService } from '../../shared-services/navigation.service';
import { Role } from '../../security/role/role.model';
import { SecurityService } from '../../security/security.service';
import { Producto } from '../../productos/producto.model';
import { AdicionalPedido } from './adicional-pedido';
import { NgForm } from '@angular/forms';
import { RespuestaPlataforma } from '../models/respuesta-plataforma';
import { Proveedor } from '../../productos/proveedor/proveedor.model';
import { ProveedorCodigo } from './dtos/proveedor-codigo';

interface IImagenColor extends IImage {
  colorId: number;
}

@Component({
  selector: 'app-pedido-details',
  templateUrl: './pedido-details.component.html',
  styleUrls: ['./pedido-details.component.scss']
})
export class PedidoDetailsComponent implements OnInit {

  @ViewChild('form') public roleForm: NgForm;

  pedido: Pedido;

  pedidoActualizado:Pedido;
  montoTotal: number;
  montoTotalIVA: number = 0;
  costoEnvioIVA: number = 0;
  transferenciaResuelta: Boolean = false;
  adicionalesResueltos: Boolean = false;
  EstadoPedido = new EstadoPedido();
  private motivosRechazo: MotivosRechazo[];
  private motivosRechazoSeleccionados: Number[];
  subclienteMonto: SubclienteMonto;
  user: any;
  rol: Role;
  nombreRol: string;
  mensajePlataforma: RespuestaPlataforma;
  proveedoresCodigoPrataforma: ProveedorCodigo[] = [];
  tipoAdicional: string;

  constructor(
    private route: ActivatedRoute,
    public router: Router,
    private backendService: BackendService,
    private snackService: SnackService,
    private dialogService: DialogService,
    private clienteService: ClienteService,
    private sanitizer: DomSanitizer,
    private authService: SecurityService,
    private navigationService: NavigationService
  ) { }

  imagen: any;
  imagenes: string[];
  logos: string[];
  imageUrlArray: IImagenColor[] = [{url: '', caption: '', href: '', colorId: 0}];
  isImageLoading: boolean;

  adicionalPedidoNuevo: AdicionalPedido = new AdicionalPedido(undefined);
  
  cantidadAdicional: number =1;
  precioAdicional:number = 0;
  precioCosto:number = 0;
  descripcion:string = "descripcion";
  iva: number;

  adicionalesDelPedido: AdicionalPedido[];
  
  
  ngOnInit() {
    this.user = this.authService.user;
    this.getRol();
    this.getProveerdorConCodigoPlataforma();
    //this.adicionalPedido.cantidad=0;
    
    this.route.data.subscribe(data => {
      console.log(data);
      this.snackService.spinner(false);
      this.pedido = data.acuerdo;
      this.pedido.productos.forEach(p => {
        p.precioIva = this.getPrecioConIva((p.precioUnitario + (p.precioAdicional * p.cantidadLogos)) * p.cantidad);        
      });
      if(this.pedido.pais.id == 63){
        this.iva = 1.19;
      }
      if(this.pedido.pais.id == 55){
        this.iva = 1.21;
      }
      this.getImagesFiles();

      this.montoTotalIVA = this.pedido.precioFinal;
      this.montoTotal = this.montoTotalIVA / 1.21;
      this.costoEnvioIVA =  this.getPrecioConIva(this.pedido.costoEnvio);
      console.log(this.pedido);
      
    });

    //this.getMotivosRechazo();
    //this.getEstadoCuentaSubcliente();
    if(this.pedido.transferenciaDni == null){
      this.pedido.transferenciaDni = "No especifica"
    }
    if(this.pedido.razonSocialTransferencia == null){
      this.pedido.razonSocialTransferencia = "No especifica"
    }
    console.log(this.pedido.estado.id);
  }
  getPrecioConIva(precio:number){
    var numeroIva = this.round(precio * 1.21)
    return numeroIva
  }
  round(num) {
    var m = Number((Math.abs(num) * 100).toPrecision(15));
    return Math.round(m) / 100 * Math.sign(num);
  }
  getImagesFiles(){
    this.pedido.productos.forEach(producto =>{
      producto.imagenes.forEach(img => this.getFiles(img.imagen))
    })
  }
  async getFiles(d: Imagen) {
    await this.clienteService.getImagenById(d.id).subscribe(data => {
      this.createImageFromBlob(data, d);
    }, error => {
      console.log(error);
    });
  }
  async createImageFromBlob(image: Blob, d: Imagen) {
    const reader = new FileReader();
    await reader.addEventListener('load', () => {
      d.url = reader.result;
    }, false);
    if (image) {
      reader.readAsDataURL(image);
    }
  }
  async getMotivosRechazo() {
    this.motivosRechazo = await this.backendService.get(MotivosRechazo, Pedido.path + 'motivosrechazos/all', null).toPromise();
  }

  async getEstadoCuentaSubcliente() {
    await this.backendService.get(SubclienteMonto, Subcliente.path + 'estado-cuenta/' + this.pedido.usuarioCliente.id)
                              .toPromise().then(value => {
                                 this.subclienteMonto = value;
                              });
  }

  async confirmRechazar() {
    this.dialogService.rechazar('Rechazar Pedido',
    '¿Está seguro que desea rechazar el Pedido ' + (this.pedido.numero ? this.pedido.numero : '') + '?', this.motivosRechazo)
    .then( res => {
      if (res) {
        this.rechazarPedido(res);
      }
    });
  }

  async rechazarPedido(res) {

    if (res) {

      this.snackService.spinner(true);

      try {
        await this.backendService.update(Pedido.path + 'rechazar' , { id: this.pedido.id, motivosRechazo: res[2], obsInterna: res[1] });
        this.snackService.success('Pedido rechazado correctamente');
        this.router.navigate([Pedido.path]);
      } catch (ex) {
        this.snackService.error(ex.message);
      } finally {
        this.snackService.spinner(false);
      }

    }

  }

  async getRol(){
    await this.backendService.get(Role,"/new-roles/user/"+this.user.id).toPromise().then(a =>{
      this.rol = a as Role;
      this.nombreRol = this.rol.name;
    });
  }

  async confirmAprobar() {
    this.dialogService.confirm('Aprobar Pedido',
    '¿Está seguro que desea aprobar el Pedido ' + (this.pedido.numero ? this.pedido.numero : '') + '?')
    .then( res => {
      if (res) {
        this.aprobarPedido(res);
      }
    });
  }

  async aprobarPedido(res) {

    if (res) {

      this.snackService.spinner(true);

      try {
        await this.backendService.update(Pedido.path + 'aprobar', { id: this.pedido.id });
        this.snackService.success('Pedido aprobado correctamente');
        this.router.navigate([Pedido.path]);
      } catch (ex) {
        this.snackService.error(ex.message);
      } finally {
        this.snackService.spinner(false);
      }

    }

  }

  async confirmReactivar() {
    this.dialogService.confirm('Reactivar Pedido',
    '¿Está seguro que desea reactivar el Pedido ' + (this.pedido.numero ? this.pedido.numero : '') + '?')
    .then( res => {
      if (res) {
        this.reactivarPedido(res);
      }
    });
  }
  async reactivarPedido(res) {

    if (res) {

      this.snackService.spinner(true);

      try {
        await this.backendService.update(Pedido.path + 'reactivar', { id: this.pedido.id });
        this.snackService.success('Pedido reactivado correctamente');
        this.router.navigate([Pedido.path]);
      } catch (ex) {
        this.snackService.error(ex.message);
      } finally {
        this.snackService.spinner(false);
      }

    }
  }

  async confirmFinalizar() {
    this.dialogService.confirm('Finalizar Pedido',
    '¿Está seguro que desea finalizar el Pedido ' + (this.pedido.numero ? this.pedido.numero : '') + '?')
    .then( res => {
      if (res) {
        this.finalizarPedido(res);
      }
    });
  }
  async finalizarPedido(res) {
    if (res) {

      this.snackService.spinner(true);

      try {
        await this.backendService.update(Pedido.path + 'finalizado', { id: this.pedido.id });
        this.snackService.success('Pedido reactivado correctamente');
        this.router.navigate([Pedido.path]);
      } catch (ex) {
        this.snackService.error(ex.message);
      } finally {
        this.snackService.spinner(false);
      }
    }
  }

  async confirmEnCurso() {
    this.dialogService.confirm('Pedido en curso',
    '¿Está seguro que desea cambiar el estado del Pedido ' + (this.pedido.numero ? this.pedido.numero : '') + ' a En Curso ?')
    .then( res => {
      if (res) {
        this.enCursoPedido(res);
      }
    });
  }
  async enCursoPedido(res) {
    if (res) {

      this.snackService.spinner(true);

      try {
        await this.backendService.update(Pedido.path + 'en-curso', { id: this.pedido.id });
        this.snackService.success('Pedido en curso');
        this.router.navigate([Pedido.path]);
      } catch (ex) {
        this.snackService.error(ex.message);
      } finally {
        this.snackService.spinner(false);
      }
    }
  }

  previsualizar(producto) {
    this.imagenes = [];
    producto.imagenes.forEach(img => {
      this.imagenes.push(img.imagen.url);
    })
    this.dialogService.imagesSliderViewer('Previsualización', '',  Observable.of(this.imagenes));
  }

  previsualizarLogo(producto) {
    this.logos = [];
    producto.imagenes.forEach(img => {
      img.logos.forEach(logo => {
        if(logo.logo.path){
          this.logos.push(logo.logo.path);  
        }
      });
    })
    this.dialogService.imagesSliderViewer('Previsualización', '',  Observable.of(this.logos));
  }

  async previsualizarComprobante(){
    try{
      await this.clienteService.getPrevisualizacionComprobante(this.pedido.comprobante).toPromise().then(data => {
        const blob = new Blob([data], {type: data.type});
        const url = window.URL.createObjectURL(blob);
        window.open(url);
      });
    } catch (ex) {
      console.log(ex);
      this.snackService.error('Error al obtener imagen de previsualización.');
    } finally {
      this.snackService.spinner(false);
    }
  }

  async getImage(id) {
    try {
      await this.clienteService.getPrevisualizacionById(id).subscribe(data => {
        const urlCreator = window.URL;
        this.imagen = this.sanitizer.bypassSecurityTrustUrl(
            urlCreator.createObjectURL(data));
            this.imageUrlArray.push({url: this.imagen.changingThisBreaksApplicationSecurity,
                                    href: this.imagen.changingThisBreaksApplicationSecurity, colorId: 0});
      });
    } catch (ex) {
      console.log(ex);
      this.snackService.error('Error al obtener imagen de previsualización.');
    } finally {
      this.snackService.spinner(false);
    }
  }

  back() {
    this.router.navigateByUrl('/pedidos');
  }

  async aprobarComprobante(){
    this.dialogService.confirm('Aprobar comprobante',
    '¿Está seguro que desea aprobar el comprobante?')
    .then( res => {
      if (res) {
       /* this.clienteService.putComprobanteAprobado(this.pedido.id).then(a =>{
          this.transferenciaResuelta = a.ok;
        });*/
        if(this.pedido.tbEspecial == null){
          this.pedido.tbEspecial = false;
        }
        this.transferenciaResuelta = this.backendService.getBoolean(Pedido.path + 'comprobante-transferencia/aprobado/' + this.pedido.id + '/' + this.pedido.tbEspecial)
        //window.location.reload();
      }
    });    
  }

  async rechazarComprobante(){
    this.dialogService.confirm('Rechazar comprobante',
    '¿Está seguro que desea rechazar el comprobante?')
    .then( res => {
      if (res) {
        /*this.clienteService.putComprobanteRechazado(this.pedido.id).then(a =>{
          this.transferenciaResuelta = a.ok;
        });*/
        this.transferenciaResuelta = this.backendService.getBoolean(Pedido.path + 'comprobante-transferencia/rechazado/' + this.pedido.id)
        //window.location.reload();
      }
    });    
  }

  //Agrega los adicionales correspondientes al pedido
  async agregarAdicionales(){
    this.snackService.spinner(true);
    this.adicionalPedidoNuevo.precioCosto =this.precioCosto;
    this.adicionalPedidoNuevo.precioUnitario = this.precioAdicional;
    this.adicionalPedidoNuevo.cantidad = this.cantidadAdicional;
    await this.backendService.update(Producto.newPath + 'carga-impresiones-adicionales/' + this.pedido.id,this.adicionalPedidoNuevo);
    await this.actualizarProductos();
    this.snackService.spinner(false);
    this.snackService.success('Adicional Agregado Correctamente');
  }

  async agregarAdicionalesSinCosto(){
    this.snackService.spinner(true);
    this.adicionalPedidoNuevo.precioCosto =this.precioCosto;
    this.adicionalPedidoNuevo.precioUnitario = this.precioAdicional;
    this.adicionalPedidoNuevo.cantidad = this.cantidadAdicional;
    this.adicionalPedidoNuevo.sinCosto = true;
    await this.backendService.update(Producto.newPath + 'carga-impresiones-adicionales/' + this.pedido.id,this.adicionalPedidoNuevo);
    await this.actualizarProductos();
    this.snackService.spinner(false);
    this.snackService.success('Adicional Agregado Correctamente');
  }

  async actualizarProductos(){

    this.pedidoActualizado = await this.backendService.get(Pedido, Pedido.path + this.pedido.id).toPromise();
    this.montoTotal = this.pedidoActualizado.precioFinal / 1.21;
    this.pedidoActualizado.productos.forEach(p => {
      //this.montoTotal += (p.precioUnitario + (p.precioAdicional * p.cantidadLogos)) * p.cantidad;
      p.precioIva = this.getPrecioConIva((p.precioUnitario + (p.precioAdicional * p.cantidadLogos)) * p.cantidad);
    });
    this.pedido.productos = this.pedidoActualizado.productos;

    this.getImagesFiles();
    
  }

  async borrarVariante(id){
    
    this.dialogService.confirm('Borrado de Variantes',
    '¿Está seguro que desea Borrar el producto del pedido?')
    .then( res => {
      if (res) {
       this.accionBorradoVariante(id);
      }
    });  
    
    
  }

  async accionBorradoVariante(id){
    let borrado;
    this.snackService.spinner(true);
    await this.backendService.delete(Pedido.path + "borrar-producto-pedido/" + id).then((res: Response) => {
      borrado = res.json();
      
    });

    await this.actualizarProductos();
    this.snackService.spinner(false);
    this.snackService.success('Producto Borrado Correctamente'); 
  }

  async finalizarAgregacionAdicionales(){
    this.dialogService.confirm('Agregación de adicionales',
    '¿Está seguro que desea cerrar el pedido?')
    .then( res => {
      if (res) {
        this.snackService.spinner(true);
       /* this.clienteService.putComprobanteAprobado(this.pedido.id).then(a =>{
          this.transferenciaResuelta = a.ok;
        });*/
        this.adicionalesResueltos = this.backendService.getBoolean(Pedido.path + 'finalizar-adicionales/' + this.pedido.id)
        //window.location.reload();

        this.snackService.spinner(false);
        this.snackService.success('Finalizó Carga de Adicionales Correctamente');
      }
    });    
  }

  async finalizarAgregacionAdicionalesSinCosto(){
    this.dialogService.confirm('Agregación de adicionales SIN COSTO',
    '¿Está seguro que desea cerrar el pedido?')
    .then( res => {
      if (res) {
        
        try{
          this.snackService.spinner(true);
          this.backendService.get(RespuestaPlataforma,Pedido.path + 'finalizar-adicionales-sin-costo/' + this.pedido.id).toPromise().then(a=>{
            this.mensajePlataforma = a as RespuestaPlataforma;
            this.snackService.success(a.mensaje);
            this.adicionalesResueltos = true;
            this.snackService.spinner(false);
            this.back();
          });
        }catch(ex){
          console.log(ex)
        }
      }
    });    
  }

  roundPrice(unitPrice, quantity){
    return Math.ceil(unitPrice*quantity);
  }

  async getProveerdorConCodigoPlataforma () {
    await this.backendService.get(ProveedorCodigo, Producto.newPath + 'proveedores-codigo-plataforma',null).toPromise().then(a =>{
      this.proveedoresCodigoPrataforma = a as ProveedorCodigo[];
    } );
  }

  asignarNombreProducto (producto) {
    if (producto.nombre == "Adicional") {
      if (producto.sinCosto)
        return producto.nombre + " sin costo";
      return producto.nombre + " con costo"
    }
    return producto.nombre;
  }

}



// WEBPACK FOOTER //
// ./src/app/pedido/pedido-details/pedido-details.component.ts